import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import WorkroomForm from './components/workroomForm';
import { updateWorkroom, requestWorkroom, navigate, clearValidationErrors } from 'actionCreators';
import { getRole, getWorkroomErrors, getWorkroomById } from '../../../../reducers';
import ui from 'redux-ui';
import { urls } from 'helpers/url';

class WorkroomEdit extends Component {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = () => { this.props.navigate(urls.workroom(props.workroom)); };
    this.setSuccessMessage = () => this.props.updateUI('successMessage', 'Changes have been saved');
  }

  componentDidMount = () => this.props.requestWorkroom(this.props.id);

  componentWillUnmount = () => this.props.clearValidationErrors('WORKROOM');

  handleSave = workroom => this.props.updateWorkroom(workroom).then(() => {
    this.props.navigate(urls.workroom(workroom));
    this.setSuccessMessage();
  });

  render = () => {
    const { errors, workroom, loading, role } = this.props;
    return (!loading ? <WorkroomForm
      role={role}
      errors={errors}
      onSave={this.handleSave}
      onCancel={this.handleCancel}
      workroom={workroom}
    /> : <p>Loading...</p>);
  }
}

WorkroomEdit.propTypes = {
  id: PropTypes.number,
  updateUI: PropTypes.func,
  errors: PropTypes.object,
  updateWorkroom: PropTypes.func.isRequired,
  requestWorkroom: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  clearValidationErrors: PropTypes.func.isRequired,
  workroom: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  role: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const id = Number(ownProps.params.id);
  const workroom = getWorkroomById(state)(id);
  return {
    id,
    workroom,
    errors: getWorkroomErrors(state) || {},
    loading: workroom ? workroom.loading : true,
    role: getRole(state),
  };
};

export default ui()(connect(
  mapStateToProps, { updateWorkroom, requestWorkroom, navigate, clearValidationErrors },
)(WorkroomEdit));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/workrooms/workroomEdit.jsx